import React from 'react';
import Dropzone, { FileRejection } from 'react-dropzone';

interface UplopadGMPIsProps {
    errors: string[];
    setErrors: (x: string[]) => void;
    loading: boolean;
    setLoading: (x: boolean) => void;
    storedFiles: DropzoneFileType[];
    setFiles: React.Dispatch<React.SetStateAction<DropzoneFileType[]>>;
}

export function UploadGMPIs({
    errors,
    setErrors,
    loading,
    setLoading,
    storedFiles,
    setFiles,
}: UplopadGMPIsProps) {
    const fileProperties = {
        maxSize: 10000000,
        acceptedTypes: ['.xlsx', '.xls', '.csv'],
    };

    function resetFileState() {
        setLoading(false);
        setErrors([]);
    }

    function fileReject(files: FileRejection[]) {
        const error: string[] = [];

        files.forEach((f) => {
            f.errors.forEach((e) => {
                if (e.code === 'file-too-large') {
                    error.push(`File is larger than 10MB (${f.file.name})`);
                } else {
                    error.push(`${e.message} (${f.file.name})`);
                }
            });
        });

        setErrors(error);
        setLoading(false);
    }

    function removeFile(file: DropzoneFileType) {
        setFiles((prev) => prev.filter((x) => x.path !== file.path));
    }

    return (
        <>
            <label htmlFor="dropzone-input" className="col-form-label">
                Member GMPIs
            </label>
            <Dropzone
                accept={fileProperties.acceptedTypes}
                maxSize={fileProperties.maxSize}
                onDrop={resetFileState}
                onDropAccepted={(files) => setFiles(files)}
                onDropRejected={fileReject}
                multiple={false}
                disabled={loading}
            >
                {({ getRootProps, getInputProps }) => (
                    <div {...getRootProps({ className: 'dropzone mb-3' })}>
                        <input {...getInputProps()} id="dropzone-input" />
                        Drop files to attach, or click to browse
                    </div>
                )}
            </Dropzone>
            {errors.length > 0 && (
                <div className="mb-2">
                    {errors.map((e) => (
                        <div className="text-danger fw-bold" key={e}>
                            {e}
                        </div>
                    ))}
                </div>
            )}

            {storedFiles.map((file) => (
                <div className="mb-1 file-list" key={file.path}>
                    <i
                        className="fa-solid fa-times-circle text-danger me-2"
                        onClick={() => removeFile(file)}
                        onKeyPress={() => removeFile(file)}
                        role="button"
                        tabIndex={0}
                        aria-label="Remove File"
                    />
                    {file.path}
                </div>
            ))}
        </>
    );
}
